import { render, staticRenderFns } from "./Sistem.vue?vue&type=template&id=11907310&"
import script from "./Sistem.vue?vue&type=script&lang=js&"
export * from "./Sistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Sistem.vue"
export default component.exports